export {
  PropertyMap
} from '@roc/ui';